import { useNavigate } from '@tanstack/react-router'
import { Button } from 'primereact/button'
import { useAuth } from '../api/hooks/useAuth'
import PaneContainer from '@/layouts/components/PaneContainer'
import SingleColumn from '@/layouts/SingleColumn'

function Home() {
  const { isAuthenticated, login } = useAuth()
  const navigate = useNavigate()

  // ログイン済みの場合はダッシュボードにリダイレクト
  if (isAuthenticated) {
    navigate({ to: '/dashboard' })
  }

  return (
    <SingleColumn>
      <PaneContainer>
        <div className="flex flex-column justify-content-center align-items-center h-full">
          <div className="w-full max-w-screen-lg">
              <div className="text-center">
                <h1 className="text-primary text-4xl mb-3">
                  <img src="/logo.png" alt="生産計画ツール" className="md:w-4 w-8 inline-block" />
                </h1>
                <h2 className="text-xl text-700 mb-5">エクセル見える化・自動化をもっと簡単に</h2>
                <p className="text-lg mb-5 line-height-3">
                  Excel上で構築された業務をAIで見える化、自動化で拡張<br />
                  Microsoftアカウントでログインしてはじめましょう。
                </p>

                <div className="mt-5 flex flex-column align-items-center justify-content-center gap-3">
                  <Button
                    label="Microsoftアカウントでログイン"
                    icon="pi pi-microsoft"
                    className="p-button-primary p-button-lg"
                    onClick={login}
                  />
                </div>
              </div>
          </div>
        </div>
      </PaneContainer>
    </SingleColumn>
  )
}

export default Home
